import React from 'react';
import { getContextConfig } from '../provider';
import { type AlertModalProps, createModalElement, SimpleModal } from './createModalElement';

const AlertModalBase = SimpleModal as React.ComponentType<AlertModalProps>;
export const AlertModal = (props: AlertModalProps) => <AlertModalBase {...props} />;

export const Alert = (properties: AlertModalProps) => {
  const { locale } = getContextConfig();
  const defaultProps: Partial<AlertModalProps> = {
    title: locale?.AlertModal.title,
    confirmText: locale?.ConfirmModal.confirmText,
  };
  const mergeProps = { ...defaultProps, ...properties };

  return new Promise<boolean | undefined>((resolve) => {
    let resolved = false;
    createModalElement<AlertModalProps>({
      ...mergeProps,
      onConfirm: () => {
        resolved = true;
        resolve(true);
        mergeProps.onConfirm?.();
      },
      onClose: () => {
        if (!resolved) {
          resolve(undefined);
        }
        mergeProps.onClose?.();
      },
    });
  });
};
